
import {  Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-preview-popup',
  standalone: true,
  imports: [],
  templateUrl: './image-preview-popup.component.html',
  styleUrl: './image-preview-popup.component.css',
})
export class ImagePreviewPopupComponent implements OnInit {
  token!:string ;
  filepath!:string;
  constructor(
    public dialogRef: MatDialogRef<ImagePreviewPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      filepath: string;
    }
  ) {
    this.filepath = data.filepath;
  }
  @HostListener('document:keydown.escape', ['$event'])
  onEscKeydown(event: any): void {
    event.stopPropagation();
    this.close();
  }
  ngOnInit(): void {

  }

  close(): void {
    this.dialogRef.close();
  }
}
